export const cardButton =
  ({ backgroundColor, backgroundImage, color }) =>
  () => ({
    backgroundImage,
    backgroundColor,
    color,
    margin: "0",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontFamily: "body",
    width: "100%",
    flexGrow: 1,
    flexShrink: 1,

    "&:focus": {
      outline: `solid 2px ${backgroundColor}`,
      outlineOffset: "2px",
    },
  });

export const labelBox = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flexGrow: 1,
  flexShrink: 1,
  width: "100%",
  padding: isMobile ? "20px" : "30px",
  minHeight: isMobile ? "124px" : "180px",
});

export const description = {
  marginBottom: "10px",
  lineHeight: "1",
};

export const selectLabel = ({
  isMobile,
  boxColor,
  textColor,
  borderTop,
  selectLabelHeight,
  selectLabelFontSizeDesktop,
  selectLabelFontSizeMobile,
  selectLabelMarginLeft,
  selectLabelTop,
  selectLabelBorderRadius,
  selectLabelWidth,
  selectLabelBorder,
}) => ({
  borderTop,
  backgroundColor: boxColor,
  borderRadius: `${selectLabelBorderRadius}`,
  gap: "10px",
  color: `${textColor}`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  height: isMobile ? "25px" : selectLabelHeight,
  flexGrow: 0,
  flexShrink: 0,
  width: selectLabelWidth ? `${selectLabelWidth}` : "100%",
  marginLeft: `${selectLabelMarginLeft}`,
  fontSize: isMobile ? selectLabelFontSizeMobile : selectLabelFontSizeDesktop,
  fontWeight: "400",
  lineHeight: "16px",
  letterSpacing: isMobile ? "0.5em" : "0.1em",
  position: "relative",
  top: `${selectLabelTop}`,
  textAlign: "center",
  border: `${selectLabelBorder}`,
  paddingRight: "5px",
});

export const logo = {
  display: "flex",
  maxWidth: "180px",
  maxHeight: "28px",
  margin: "auto 0",
  fill: "#fff",
  filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.25))",
  width: "100%",
};

export const bauerLogo = {
  display: "flex",
  maxWidth: "100px",
  maxHeight: "16px",
  margin: "auto 0",
  fill: "#fff",
  filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.25))",
  width: "100%",
};

export const productLogo = {
  display: "flex",
  margin: "auto 0",
  fill: "#fff",
  filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.25))",
  width: "100%",
  justifyContent: "center",
};

export const hyperliteLogo = {
  maxWidth: "137px",
  maxHeight: "11px",
};

export const syncLogo = {
  maxWidth: "72px",
  maxHeight: "10px",
};

export const ultraLogo = {
  maxWidth: "84px",
  maxHeight: "20px",
};

export const subText = {
  fontSize: "16px",
  letterSpacing: "0.05em",
  lineHeight: "1",
  marginTop: "10px",
};
